export default __webpack_public_path__ + "static/img_5-28f6adbf502e99e5a16fcd340710f09e.png";